import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Customers = lazy(() => import('./Customers'));

/**
 * The Customers routes.
 */
const customersRoutes: FuseRouteItemType[] = [
	{
		path: 'customers',
		children: [
			{
				index: true,
				element: <Customers />
			},
			{
				path: ':customerId',
				element: <Customers />
			}
		]
	}
];

export default customersRoutes;
